import { Component, Input } from '@angular/core';
import { WorkflowAuditIssue, WorkflowAuditIssueType } from './audit.service';


@Component({
    selector: 'eas-workflow-audit-issue-list-item',
    template: `<mat-list-item [class.mt-1]="!isFirst">
              <mat-icon mat-list-icon>{{ issueTypeToIcon(issue.type) }}</mat-icon>
              <div class="small">{{ issue.description }}</div>
            </mat-list-item>`,
    styles: [`
  .mat-mdc-list-base .mat-mdc-list-item {
    height: auto;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
  `],
    standalone: false
})
export class WorkflowAuditIssueListItemComponent {
  @Input() issue!: WorkflowAuditIssue;
  @Input() isFirst = false;
  @Input() isLast = false;

  //
  // Template helpers
  //

  public issueTypeToIcon(type: WorkflowAuditIssueType): string {
    switch (type) {
      case 'suggestion':
        return 'help_outline';
      case 'error':
      case 'warning':
        return type;
    }
  }
}
